// extracted by mini-css-extract-plugin
export var author = "page-module--author--OBMiZ";
export var content = "page-module--content--w1w2f";
export var contentWrapper = "page-module--contentWrapper--hr6fi";
export var root = "page-module--root--biluL";